/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.membership.cards.controllers', [])

.controller('LayoutsMembershipCardsController', ['$scope', function($scope) {

    $scope.layoutsMembershipCards = {

      model: "Your spankin new application.layouts.membership.cards view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.layoutsMembershipCards.init();

}]);
